import { render } from "./TheFooter.vue?vue&type=template&id=b40baa8e&scoped=true&ts=true"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"

import "./TheFooter.vue?vue&type=style&index=0&id=b40baa8e&scoped=true&lang=less"

import exportComponent from "/mnt/f/Projects/Vue/typescript-neo/neo-sanctum/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b40baa8e"]])

export default __exports__